import { render, staticRenderFns } from "./imgEdit.vue?vue&type=template&id=2f933998&scoped=true"
import script from "./imgEdit.vue?vue&type=script&lang=js"
export * from "./imgEdit.vue?vue&type=script&lang=js"
import style0 from "./imgEdit.vue?vue&type=style&index=0&id=2f933998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f933998",
  null
  
)

export default component.exports